var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"no-results-found"},[_vm._v(" "+_vm._s(_vm.message)+" "),(_vm.hasArchiveLink)?[_vm._v(" You can also "),_c('button',{staticClass:"no-results-found__cta",on:{"click":_vm.handleClick}},[_vm._v(" search the archive")]),_vm._v(". ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }